import React, { useMemo } from 'react';
import Table from '../../../atoms/table/Table';
import { IconButton } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { MRT_ColumnDef, MRT_TableInstance } from 'material-react-table';
import { ILevelData } from '../../../store/api/types/leadership';
import { useActions } from '../../../hooks/actions';
import { useDeleteLevelMutation } from '../../../store/api/leadership';

interface IProps {
  data?: ILevelData[];
  isLoading: boolean;
  tableInstanceRef: React.RefObject<MRT_TableInstance>;
}

const LevelsVLTable = ({ data, isLoading, tableInstanceRef }: IProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const { openEditLevelVLModal, toggleSuccessSnackbar, toggleErrorSnackbar } =
    useActions();

  const [deleteLevel] = useDeleteLevelMutation();

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = (row: ILevelData) => {
    openEditLevelVLModal(row);
    setAnchorEl(null);
  };

  const handleDelete = (levelId: string) => {
    if (levelId) {
      deleteLevel(levelId)
        .unwrap()
        .then(() =>
          toggleSuccessSnackbar({
            message: 'Level Deleted Successfully',
          })
        )
        .catch(({ data }) => toggleErrorSnackbar({ message: data.detail }));
    }
    setAnchorEl(null);
  };

  const columns = useMemo<MRT_ColumnDef<ILevelData>[]>(
    () => [
      {
        header: 'Level Name',
        accessorKey: 'fieldValue',
        filterFn: 'includesString',
        size: 400,
      },
      {
        header: 'Level ID',
        accessorKey: 'code',
        filterFn: 'includesString',
        size: 400,
      },
      {
        header: '# of Roles with Level',
        accessorFn: () => '',
      },
    ],
    []
  );

  return (
    <Table
      data={data ?? []}
      tableInstanceRef={tableInstanceRef}
      columns={columns as MRT_ColumnDef<object>[]}
      renderRowActions={({ cell, row }) => (
        <>
          <IconButton
            id={cell.id}
            onClick={handleOpen}
          >
            <MoreVert />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={anchorEl?.id === cell.id}
            onClose={handleClose}
          >
            <MenuItem onClick={() => handleEdit(row.original as ILevelData)}>
              Edit
            </MenuItem>
            <MenuItem
              onClick={() =>
                handleDelete((row.original as ILevelData).id || '')
              }
            >
              Delete
            </MenuItem>
          </Menu>
        </>
      )}
      state={{ showSkeletons: isLoading }}
    />
  );
};

export default LevelsVLTable;
